import React from 'react';
import { GooglePreviewProps } from './types';
import { 
  formatBusinessTypes, 
  getBusinessTypeIcon, 
  formatRating, 
  formatOperatingHours, 
  getGoogleMapsUrl 
} from '../../../../services/google-places';

const GooglePreview: React.FC<GooglePreviewProps> = ({ googlePreview }) => {
  return (
    <div style={{ 
      marginBottom: '1rem',
      padding: '1rem',
      backgroundColor: '#e8f5e8',
      borderRadius: '4px',
      border: '1px solid #4caf50'
    }}>
      <h5 style={{ marginBottom: '0.5rem', color: '#2e7d32' }}>
        📍 Business Information from Google
      </h5>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: '0.5rem', 
        fontSize: '0.9rem' 
      }}>
        <div><strong>Business:</strong> {googlePreview.name}</div>
        <div><strong>Address:</strong> {googlePreview.address.formatted_address}</div>
        {googlePreview.phone && <div><strong>Phone:</strong> {googlePreview.phone}</div>}
        {googlePreview.website && (
          <div>
            <strong>Website:</strong> 
            <a 
              href={googlePreview.website} 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ marginLeft: '0.25rem', color: '#1976d2' }}
            >
              {googlePreview.website}
            </a>
          </div>
        )}
        {googlePreview.rating && (
          <div>
            <strong>Rating:</strong> {formatRating(googlePreview.rating, googlePreview.google_data?.user_ratings_total)}
          </div>
        )}
        {googlePreview.business_types && googlePreview.business_types.length > 0 && (
          <div>
            <strong>Business Type:</strong> 
            <span style={{ marginLeft: '0.25rem' }}>
              {getBusinessTypeIcon(googlePreview.business_types)} {formatBusinessTypes(googlePreview.business_types).join(', ')}
            </span>
          </div>
        )}
        {googlePreview.operating_hours && (
          <div><strong>Hours:</strong> {formatOperatingHours(googlePreview.operating_hours)}</div>
        )}
        {googlePreview.distance_miles && (
          <div><strong>Distance:</strong> {googlePreview.distance_miles.toFixed(2)} miles</div>
        )}
        {googlePreview.business_status && (
          <div><strong>Status:</strong> {googlePreview.business_status}</div>
        )}
      </div>
      {googlePreview.address.google_place_id && (
        <div style={{ marginTop: '0.5rem' }}>
          <a 
            href={getGoogleMapsUrl(googlePreview.address.google_place_id)} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#1976d2',
              textDecoration: 'none',
              fontSize: '0.9rem'
            }}
          >
            🗺️ View on Google Maps
          </a>
        </div>
      )}
    </div>
  );
};

export default GooglePreview;
